import { useState, useEffect, useContext } from "react";
import { SiteContext } from "../contexts/SiteContext";
import {
	Paper,
	Typography,
	makeStyles,
	Fade,
	useTheme,
} from "@material-ui/core";
import DOMPurify from "dompurify";
import WarningIcon from "@material-ui/icons/Warning";

function Warning({ margin }) {
	const [warning, setWarning] = useState();
	const [loading, setLoading] = useState(true);
	const { selectedSite } = useContext(SiteContext);
	const theme = useTheme();

	const useStyles = makeStyles((theme) => ({
		paper: {
			margin: margin ? margin : "none",
			padding: "1rem",
		},
	}));

	const classes = useStyles();

	useEffect(() => {
		const fetchData = async () => {
			const url = `${process.env.REACT_APP_API_URL}/sites?_id=${selectedSite._id}&select=warning&populates=false`;
			const res = await fetch(url, { credentials: "include" });
			const site = await res.json();
			if (site.success) {
				site.data[0].warning && setWarning(site.data[0].warning);
			} else {
				console.log(site.error);
			}
		};
		fetchData();
		setLoading(false);
	}, [selectedSite]);

	if (loading) {
		return "Loading...";
	}

	// Only return content if there is a site warning
	if (warning) {
		return (
			<Fade in={!loading}>
				<Paper className={classes.paper}>
					<Typography component="span" variant="h6">
						<div style={{ display: "flex" }}>
							<WarningIcon
								fontSize="large"
								style={{
									color: theme.palette.warning.main,
									marginRight: ".5rem",
								}}
							/>
							Content Warning
						</div>
					</Typography>
					<Typography
						dangerouslySetInnerHTML={{
							__html: DOMPurify.sanitize(warning),
						}}
					/>
				</Paper>
			</Fade>
		);
	} else {
		return "";
	}
}

export default Warning;
